var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome02 = function SvgHome02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.667 18.75c-.69 0-1.25.56-1.25 1.25v6.667c0 .69.56 1.25 1.25 1.25h6.666c.69 0 1.25-.56 1.25-1.25V20c0-.69-.56-1.25-1.25-1.25zm1.25 6.667V21.25h4.166v4.167z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.116 4.116a1.25 1.25 0 0 1 1.768 0l15 15A1.25 1.25 0 0 1 35 21.25h-2.083v10.417a4.583 4.583 0 0 1-4.584 4.583H11.667a4.584 4.584 0 0 1-4.584-4.583V21.25H5a1.25 1.25 0 0 1-.884-2.134zm11.3 27.55V20c0-.69.56-1.25 1.25-1.25h.316L20 6.768 8.018 18.75h.315c.69 0 1.25.56 1.25 1.25v11.667a2.083 2.083 0 0 0 2.084 2.083h16.666a2.084 2.084 0 0 0 2.084-2.083",
    clipRule: "evenodd"
  })));
};
export default SvgHome02;